export { StoreDetailsServer } from './dealer-details-server';
